/**
 * Quality permission keys (catalog `quality.*`, docs/contracts/quality.md §6). The UI hides what a key does not allow; the
 * API checks the same keys and the separation of recorder, approver and decision-maker per lot (QM4).
 */
export const qualityPermissions = {
  moduleView: "quality.quality.view",
  planView: "quality.inspection_plan.view",
  planCreate: "quality.inspection_plan.create",
  planUpdate: "quality.inspection_plan.update",
  planDelete: "quality.inspection_plan.delete",
  planRelease: "quality.inspection_plan.post",
  triggerView: "quality.inspection_trigger.view",
  triggerCreate: "quality.inspection_trigger.create",
  triggerUpdate: "quality.inspection_trigger.update",
  triggerDelete: "quality.inspection_trigger.delete",
  lotView: "quality.inspection_lot.view",
  lotCreate: "quality.inspection_lot.create",
  lotRecord: "quality.inspection_lot.update",
  lotApprove: "quality.inspection_lot.approve",
  lotDecide: "quality.inspection_lot.post",
  lotDelete: "quality.inspection_lot.delete",
  lotPrint: "quality.inspection_lot.print",
  notificationView: "quality.notification.view",
  notificationCreate: "quality.notification.create",
  notificationUpdate: "quality.notification.update",
  notificationDelete: "quality.notification.delete",
  notificationVerify: "quality.notification.verify",
  samplingPointView: "quality.sampling_point.view",
  samplingPointCreate: "quality.sampling_point.create",
  samplingPointUpdate: "quality.sampling_point.update",
  samplingPointDelete: "quality.sampling_point.delete",
  policyView: "quality.policy_document.view",
  policyCreate: "quality.policy_document.create",
  policyUpdate: "quality.policy_document.update",
  policyDelete: "quality.policy_document.delete",
  policyApprove: "quality.policy_document.approve",
  setupView: "quality.setup.view",
  setupUpdate: "quality.setup.update",
} as const;

/** Plan module of Quality (P6). */
export const qualityModule = "quality";

/** The quality settings group (`/platform/settings/quality`). */
export const qualitySettingsGroup = "quality";
